// Permisos del sistema

export const VIEW_PERMISSION_LIST = 'VIEW_PERMISSION_LIST';
export const VIEW_DOCUMENTS_OF_TERMS_AND_CONDITIONS = 'VIEW_DOCUMENTS_OF_TERMS_AND_CONDITIONS';
export const UPLOAD_DOCUMENT_TERMS_AND_CONDITIONS ="UPLOAD_DOCUMENT_TERMS_AND_CONDITIONS"
export const  DOWNLOAD_DOCUMENT_FROM_TERMS_AND_CONDITIONS = " DOWNLOAD_DOCUMENT_FROM_TERMS_AND_CONDITIONS"
// Permisos para grupos

export const CREATE_GROUP = 'CREATE_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const VIEW_GROUP_BY_ID = 'VIEW_GROUP_BY_ID';
export const VIEW_ALL_GROUPS = 'VIEW_ALL_GROUPS';

// Permisos para usuarios
export const RECOVER_PASSWORD = "RECOVER_PASSWORD"
export const VIEW_USER_BY_ID = 'VIEW_USER_BY_ID';
export const VIEW_LIST_OF_USERS = 'VIEW_LIST_OF_USERS';
export const VIEW_MAILS = 'VIEW_MAILS';
export const UPDATE_MAILS = 'UPDATE_MAILS';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_STATUS_OF_USER = 'UPDATE_STATUS_OF_USER';
export const CONFIRMATION_USER = 'CONFIRMATION_USER';
export const CREATE_ADMINISTRATOR = 'CREATE_ADMINISTRATOR';
export const CREATE_MANAGER = 'CREATE_MANAGER';
export const UPDATE_MANAGER = 'UPDATE_MANAGER';
export const VIEW_MANAGER_LIST = 'VIEW_MANAGER_LIST';
export const VIEW_USER_ASSOCIATED_LIST = 'VIEW_USER_ASSOCIATED_LIST';

// Permisos para programa previo

export const VIEW_PREVIOUS_PROGRAM = 'VIEW_PREVIOUS_PROGRAM';
export const GET_CALENDAR = 'GET_CALENDAR';
export const GET_CEMENT = 'GET_CEMENT';
export const GET_MONTH = 'GET_MONTH';
export const GET_PLANT_OF_COMPANY = 'GET_PLANT_OF_COMPANY';
export const GET_RETIREMENT = 'GET_RETIREMENT';

// Permisos para ver detalle del programa previo

export const VIEW_PREVIOUS_PROGRAM_DETAIL= 'VIEW_PREVIOUS_PROGRAM_DETAIL';
export const GET_CEMENT_DETAIL = 'GET_CEMENT_DETAIL';
export const GET_DATE_DETAILS = 'GET_DATE_DETAILS';
export const GET_PLANT_DETAILS_OF_COMPANY = 'GET_PLANT_DETAILS_OF_COMPANY';
export const GET_DOCUMENT_EXCEL = 'GET_DOCUMENT_EXCEL';
export const GET_RETIREMENT_DETAILS = 'GET_RETIREMENT_DETAILS';

// Permisos para pagos

export const PAYMENT= 'PAYMENT';
export const PAYMENT_DETAIL = 'PAYMENT_DETAIL';
export const ADVANCE_PAYMENT = 'ADVANCE_PAYMENT';
export const VIEW_ANTICIPATION_PAYMENT = 'VIEW_ANTICIPATION_PAYMENT';
export const SAVE_INVOICE = 'SAVE_INVOICE';
export const SAVE_ANTICIPATION = 'SAVE_ANTICIPATION';
export const GET_YEAR = 'GET_YEAR';
export const GET_INVOICE = 'GET_INVOICE';
export const GET_PDF_OF_INVOICE = 'GET_PDF_OF_INVOICE';
export const GET_PAYMENT_CONCEPT = 'GET_PAYMENT_CONCEPT';
export const TRUE_PAYMENT = 'TRUE_PAYMENT';
export const FALSE_PAYMENT = 'FALSE_PAYMENT';
export const GET_TYPE_INVOICE = 'GET_TYPE_INVOICE';
export const GET_EXCEL_INVOICE = 'GET_EXCEL_INVOICE';
export const SAVE_PAYMENT_INFORMATION = 'SAVE_PAYMENT_INFORMATION';
export const DELETE_CANCELED_PAYMENT = 'DELETE_CANCELED_PAYMENT';
export const DELETE_CANCELED_PAYMENT_ANTICIPATION = 'DELETE_CANCELED_PAYMENT_ANTICIPATION';
export const PAYMENT_REQUEST_TO_BANK = "PAYMENT_REQUEST_TO_BANK"
export const VALIDATE_IF_YOU_CAN_PAY_WITH_BAJIO = "VALIDATE_IF_YOU_CAN_PAY_WITH_BAJIO"
export const GET_DETAIL_PAYMENT = "GET_DETAIL_PAYMENT"
export const SAVE_INVOICE_DATA = "SAVE_INVOICE_DATA"
export const SAVE_ADVENCE_PAYMENT = "SAVE_ADVANCE_PAYMENT"
export const DELETE_INFORMATION_FROM_ADVANCE_PAYMENT = "DELETE_INFORMATION_FROM_ADVANCE_PAYMENT"
export const DELETE_INFORMATION_FROM_PAYMENT = "DELETE_INFORMATION_FROM_PAYMENT"
// Permisos para ordenes de venta
export const CREATE_SECTION = "CREATE_SECTION"
export const UPDATE_SETION = "UPDATE_SETION"
export const DELETE_SECTION_BYID = "DELETE_SECTION_BYID"
export const SALE_ORDERS= 'SALE_ORDERS';
export const GET_DATE_ORDER = 'GET_DATE_ORDER';
export const GET_PLANT_ORDER_OF_COMPANY = 'GET_PLANT_ORDER_OF_COMPANY';
export const GET_EXCEL_SALE_ORDER = 'GET_EXCEL_SALE_ORDER';

// Permisos para contenidos
export const VIEW_CONTENT_MARKETING = 'VIEW_CONTENT_MARKETING';
export const TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
export const CREATE_CONTENT_MARKETING= 'CREATE_CONTENT_MARKETING';
export const UPDATE_CONTENT_MARKETING= 'UPDATE_CONTENT_MARKETING';
export const GET_DOCUMENT = 'GET_DOCUMENT';
export const GET_DOCUMENT_BY_ID = 'GET_DOCUMENT_BY_ID';
export const GET_SECTION = 'GET_SECTION';
export const CREATE_DOCUMENT = 'CREATE_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENT_BY_ID = 'DELETE_DOCUMENT_BY_ID';

// Permisos para estados de cuenta

export const DOWNLOAD_ACCOUNT_STATUS = 'DOWNLOAD_ACCOUNT_STATUS';

// Permisos para descuentos y facturas

export const GET_DISCOUNT_INVOICE_HEADER = 'GET_DISCOUNT_INVOICE_HEADER';
export const GET_DISCOUNT_INVOICE_DETAIL = 'GET_DISCOUNT_INVOICE_DETAIL';
export const GET_DISCOUNT_INVOICE_DETAIL_ORIGIN = 'GET_DISCOUNT_INVOICE_DETAIL_ORIGIN';
export const GET_EXCEL_OF_DISCOUNT_INVOICE_HEADER = 'GET_EXCEL_OF_DISCOUNT_INVOICE_HEADER';
export const GET_EXCEL_OF_DISCOUNT_INVOICE_ORIGIN = 'GET_EXCEL_OF_DISCOUNT_INVOICE_ORIGIN'
export const GET_EXCEL_OF_DISCOUNT_INVOICE_APPLICATION = 'GET_EXCEL_OF_DISCOUNT_INVOICE_APPLICATION'; 
export const GET_EXCEL_OF_INVOICE_CONSULTATION_HEADER = "GET_EXCEL_OF_INVOICE_CONSULTATION_HEADER"
export const GET_EXCEL_OF_INVOICE_CONSULTATION_DETAIL = "GET_EXCEL_OF_INVOICE_CONSULTATION_DETAIL"
export const GET_DETAILS_OF_PAYMENT = "GET_DETAILS_OF_PAYMENT"
export const UPDATE_REFERENCE_Of_PAYMENT = "UPDATE_REFERENCE_Of_PAYMENT"
// Permisos para manejo de anticipos y facturas

export const VIEW_MANAGEMENT_ADVANCES_INVOICES = 'VIEW_MANAGEMENT_ADVANCES_INVOICES';
export const VIEW_MANAGEMENT_ADVANCES_INVOICES_DETAIL = 'VIEW_MANAGEMENT_ADVANCES_INVOICES_DETAIL';
export const GET_EXCEL_OF_ADVANCES_INVOICES_HEADER = 'GET_EXCEL_OF_ADVANCES_INVOICES_HEADER'
export const GET_EXCEL_OF_ADVANCES_INVOICES_DETAIL  = 'GET_EXCEL_OF_ADVANCES_INVOICES_DETAIL'
//Permisos para administrador de zona

export const VIEW_LIST_AN8 = 'VIEW_LIST_AN8';
export const CREATE_ZONE_ADMINISTRATOR = 'CREATE_ZONE_ADMINISTRATOR';
export const ASSIGN_AN8_TO_ZONE_MANAGER = 'ASSIGN_AN8_TO_ZONE_MANAGER';
export const UPDATE_ASSIGNMENT_AN8_TO_ZONE_MANAGER = 'UPDATE_ASSIGNMENT_AN8_TO_ZONE_MANAGER';

//Permisos para consulta de facturas
export const  GET_INVOICE_PAID = "GET_INVOICE_PAID"
export const  GET_INVOICE_STATUS = "GET_INVOICE_STATUS"
export const GET_INVOICE_CONSULTATION_HEADER = 'GET_INVOICE_CONSULTATION_HEADER';
export const GET_DETAIL_SALES = 'GET_DETAIL_SALES';
export const GET_DETAIL_DISCOUNT = 'GET_DETAIL_DISCOUNT';
export const GET_DETAIL_ANTICIPATION = 'GET_DETAIL_ANTICIPATION';
export const DOWNLOAD_HEADER_PDF = 'DOWNLOAD_HEADER_PDF';
export const GET_EXCEL_OF_ANTICIPATION_PAYMENT = 'GET_EXCEL_OF_ANTICIPATION_PAYMENT'

// export const = '';

//permisos para pagos perocesados
export const GET_EXCEL_OF_PAYMENT_PROCESSED = 'GET_EXCEL_OF_PAYMENT_PROCESSED'

//permisos para pago de contado
export const HAS_CASH_PAYMENT_PERMITS = "HAS_CASH_PAYMENT_PERMITS"

//permisos para slider 
export const UPLOAD_MULTIMEDIA_FOR_SLIDER = 'UPLOAD_MULTIMEDIA_FOR_SLIDER'
export const DELETE_IMAGES_OF_THE_SLIDER = 'DELETE_IMAGES_OF_THE_SLIDER'
export const MODIFY_NAME_OF_IMAGES_OF_THE_SLIDER = 'MODIFY_NAME_OF_IMAGES_OF_THE_SLIDER'

export const VIEW_LIST_OF_IMAGES_OF_THE_SLIDER = 'VIEW_LIST_OF_IMAGES_OF_THE_SLIDER'